import { render, staticRenderFns } from "./UploadIcon.vue?vue&type=template&id=dc7b9e42"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc7b9e42')) {
      api.createRecord('dc7b9e42', component.options)
    } else {
      api.reload('dc7b9e42', component.options)
    }
    module.hot.accept("./UploadIcon.vue?vue&type=template&id=dc7b9e42", function () {
      api.rerender('dc7b9e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/UploadIcon.vue"
export default component.exports